export async function pushToDataLayer (data) {
    window.dataLayer = window.dataLayer || [];
    dataLayer = window.dataLayer;

    if (dataLayer !== undefined) {
        dataLayer.push(data)
        // console.log('Event pushed to data layer: ' + data.event);
    }
}